import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from 'react-router-dom';
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Row,
  UncontrolledDropdown,
  UncontrolledTooltip
} from "reactstrap";
import ToastDialog from "common/ToastDialog";

//Import Breadcrumb
import Breadcrumbs from "components/Common/BreadcrumbTitle";

import DeleteModal from "../../components/Common/DeleteModal";

import { getRole, deleteRole } from "../../helpers/UAM/role.helper";

import TableContainerV1 from "components/Common/TableContainerV1";
import { isEmpty } from "lodash";


const TableActionsComponent = (rowData, handleDeleteRole) => {
  const navigate = useNavigate();
  const { roleName } = JSON.parse(localStorage.getItem("user"))
  const navigateToEditRoles = (id) => {
    const encryptedId = btoa(id.toString());
    navigate(`/${roleName}/edit-roles?id=${encodeURIComponent(encryptedId)}`);
  };

  return (
    <UncontrolledDropdown>
      <DropdownToggle tag="a" className="card-drop">
        <i className="mdi mdi-dots-horizontal font-size-18"></i>
      </DropdownToggle>

      <DropdownMenu className="dropdown-menu-end">
        <DropdownItem
          onClick={() => { navigateToEditRoles(rowData.id) }
          }
        >
          <i className="mdi mdi-pencil font-size-16 text-success me-1" id="edittooltip"></i>
          Edit
          <UncontrolledTooltip placement="top" target="edittooltip">
            Edit
          </UncontrolledTooltip>
        </DropdownItem>
        <DropdownItem
          className="d-flex align-items-center"
          onClick={() => {
            handleDeleteRole(rowData);
          }
          }
        >
          <i className="fas fa-trash font-size-16 text-danger me-1" id="deletetooltip"></i>
          Delete
          <UncontrolledTooltip placement="top" target="deletetooltip">
            Delete
          </UncontrolledTooltip>
        </DropdownItem>
      </DropdownMenu>

    </UncontrolledDropdown>
  )
}



const Roles = props => {

  //meta title
  document.title = "Role List | DMS";
  const { roleName } = JSON.parse(localStorage.getItem("user"))

  const navigate = useNavigate();

  const [pagination, setPagination] = useState({ pageIndex: 0, pageCount: 0, totalRecords: 0 });
  const [pageSize, setPageSize] = useState(10);
  const [searchValue, setSearchValue] = useState("");
  const [columnId, setColumnId] = useState("id");
  const [sortingOrderStatus, setSortingOrderStatus] = useState("asc");
  const [sortingOptions, setSortingOptions] = useState({ column: 'id', isAsc: false, optionalColumn: ['Action', 'address'] })
  const [roleList, setRoleList] = useState([]);
  const [deleteModalInfo, setDeleteModalInfo] = useState({});//for delete modal
  const [toastInfo, setToastInfo] = useState({ showToast: false });

  const columns = useMemo(
    () => [
      {
        Header: 'Id',
        accessor: 'id',
        filterable: true,
        Cell: (cellProps) => {
          return cellProps.value;
        }
      },
      {
        Header: 'Role Name',
        accessor: 'displayName',
        filterable: true,
        Cell: (cellProps) => {
          return cellProps.value;
          ;
        }
      },
      {
        Header: 'Description',
        accessor: 'roleDescription',
        filterable: true,
        Cell: (cellProps) => {
          return cellProps.value;
        }
      },
      {
        Header: 'Action',
        Cell: (cellProps) => {
          const rowData = cellProps.row.original;
          return TableActionsComponent(rowData, handleDeleteRole)
        }
      },
    ],
    []
  );

  const handlePageChange = (page, pageSize, searchKey=searchValue, columnName = columnId, sortingOrder = sortingOrderStatus) => {
    setPageSize(pageSize);
    getRole({ page, limit: pageSize, searchKey, columnName, sortingOrder })
      .then(responseFromAPI => {
        if (responseFromAPI.status && responseFromAPI.code == 200) {
          setRoleList(responseFromAPI.data.data);
          const { totalItems, totalPages, currentPage } = responseFromAPI.data
          setPagination({ pageIndex: currentPage, pageCount: totalPages, totalRecords: totalItems });
        } else {
          setPagination({ pageIndex: 0, pageCount: 0, totalRecords: 0 })
          setRoleList([])
        }
      }).catch(error => { })

  }

  const handleSortColumn = (option) => {
    setSortingOptions(option)
    const columnName = option.column;
    setColumnId(columnName)
    const sortingOrder = option.isAsc ? "asc" : "desc";
    setSortingOrderStatus(sortingOrder)
    handlePageChange(1, pageSize, searchValue, columnName, sortingOrder)
  }

  const handleSearchFilter = (value, pageSize) => {
    setSearchValue(value)
    handlePageChange(1, pageSize, value);
  }
  const handleClearSearch = () => {
    setSearchValue("")
    handlePageChange(1, pageSize, "")
  }

  useEffect(() => {
    getRole()
      .then(responseFromAPI => {
        if (responseFromAPI.status && responseFromAPI.code == 200) {
          setRoleList(responseFromAPI.data.data);
          const { totalItems, totalPages, currentPage } = responseFromAPI.data
          setPagination({ pageIndex: currentPage, pageCount: totalPages, totalRecords: totalItems });
        }
      }).catch(error => { })
  }, []);

  const handleCustomerClicks = () => {
    navigate(`/${roleName}/add-roles`)
  };
  const buttonSection = (
    <div className="text-sm-end">
        <Button
          type="button"
          color="success"
          className="btn-rounded mb-2 me-2"
          onClick={handleCustomerClicks}
        >
          <i className="mdi mdi-plus me-1" />
          {'New Role'}
        </Button>
    </div>);

  const handleDeleteRole = (info) => {
    setDeleteModalInfo(info);
  }

  const deleteRoleById = async () => {
    const { id } = deleteModalInfo;
    const response = await deleteRole({ id });
    if (response.status) {
      setToastInfo({ message: response.message, showToast: true, role: "success" });
      setDeleteModalInfo({});
      getRole()
        .then(responseFromAPI => {
          if (responseFromAPI.status && responseFromAPI.code == 200) {
            setRoleList(responseFromAPI.data.data);
            const { totalItems, totalPages, currentPage } = responseFromAPI.data
            setPagination({ pageIndex: currentPage, pageCount: totalPages, totalRecords: totalItems });
          }
        }).catch(error => { })
    } else {
      setToastInfo({ message: (response.message || 'Deleting Role Failed! Please Try Again.'), showToast: true, role: "error" });
    }
  }
  return (
    <div className="page-content">
       <DeleteModal
        name={"Dealer"}
        show={!isEmpty(deleteModalInfo)}
        onDeleteClick={deleteRoleById}
        onCloseClick={() => setDeleteModalInfo({})}
      />
      <Container fluid>
        <Breadcrumbs title="ROLE LIST" />
        <Row className="vertical-scroll">
          <Col xs="12">
            <Card>
              <CardBody>
                <TableContainerV1
                  columns={columns}
                  data={roleList}
                  pagination={pagination}
                  handlePageChange={handlePageChange}
                  handleSearchFilter={handleSearchFilter}
                  customSection={buttonSection}
                  sortOptions={sortingOptions}
                  handleSortColumn={handleSortColumn}
                  handleClearSearch={handleClearSearch}
                  className="custom-header-css"
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
      {toastInfo.showToast && <ToastDialog
        message={toastInfo.message || ""}
        showToast={toastInfo.showToast}
        role={toastInfo.role}
        onCloseFn={() => setToastInfo({ showToast: false })}
      ></ToastDialog>}
    </div>
  );
};



export default Roles;
